import { ColorModeScript } from '@chakra-ui/react'
import Head from 'next/head'
import { LocalStorageWrapper } from './localStorageF/LocalStorWrapF.tsx'
import { ReportJsErrorWrap } from './ReportJsErrWrapF.jsx'
import { ptExtendTheme } from './Chakra3F/extendThemeF.jsx'
import { PtChakraProv } from './Chakra3F/ChakraF.jsx'

export const Body100PctCss = ({extraCss=''}) => {
  const __html = `
body,html,#__next{height:100%;margin:0;padding:0;}
${extraCss}
`.trim()
  return <style {...{type: 'text/css', dangerouslySetInnerHTML: {__html}}} />
}

export const PageWrapTemplate = (/** @type {{children: any, headComp?: any, initialColorMode?: any, theme?: any, noIcon?: boolean, title?: any}} */ {
  children, headComp, initialColorMode, theme,
  noIcon=true,
  title // prefer SiteTitleWrap
}) => {
  theme ||= ptExtendTheme({initialColorMode})

  return <>
    <Head>
      {title && <title key={'title'}>{title}</title>}
      {noIcon && <link {...{rel: 'icon', href: 'data:;base64,='}} />}
      {headComp}
    </Head>
    <LocalStorageWrapper>
      <PtChakraProv {...{theme}}>
        <ColorModeScript {...{initialColorMode}} />
        <ReportJsErrorWrap>
          {children}
        </ReportJsErrorWrap>
      </PtChakraProv>
    </LocalStorageWrapper>
  </>
}
